import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getBrowserDetector } from 'qp-utility';
import { DataService } from '../../../data.service';
import { StorefrontService } from '../../../storefront/storefront.service';
import { deepLink } from '../../utils/browserUtils';
import { TabService } from '../tabs/tab.service';
import { AdaptorData } from './../../../storefront/AdaptorData';
import { AdaptedPayload } from './modal/AdaptedPayload';
import { getAdaptedPayload, getSplitedPayload } from './tizenServiceUtils';
import { RoutingService } from '../routing.service';
import { LocalStorageService } from '../storage/local-storage.service';
import { AuthService } from '../auth/auth.service';
import { KEYS } from '../../utils/constants/storage.constants';

@Injectable({
  providedIn: 'root',
})
export class TizenService {
  constructor(
    private readonly router: Router,
    private readonly storefrontService: StorefrontService,
    private readonly dataService: DataService,
    private readonly tabService: TabService,
    private readonly routingService: RoutingService,
    private readonly localStorage: LocalStorageService,
    private readonly authService: AuthService
  ) {}

  async checkOperation(): Promise<void> {
    if (
      getBrowserDetector().isTizen() &&
      !this.dataService.isTizenPreviewShown
    ) {
      this.dataService.isTizenPreviewShown = true;
      const payload = deepLink();
      // console.log('payload', payload);
      const adaptedPayload = payload?.assetId
        ? getSplitedPayload(payload?.assetId)
        : getAdaptedPayload(payload);
      if (
        adaptedPayload &&
        adaptedPayload.contentType &&
        adaptedPayload.resourceId &&
        adaptedPayload.catalogLanguage
      ) {
        this.handleRedirect(adaptedPayload);
      } else if (adaptedPayload?.url) {
        this.router.navigate([adaptedPayload.url], {
          state: { tabId: adaptedPayload.url },
        });
      }
    }
  }

  public async handleRedirect(payload: AdaptedPayload): Promise<void> {
    this.autoSkipOnboarding();
    if (payload.isPlayable) {
      this.redirectToPlayer(payload);
    } else {
      console.log(
        '🎯 TizenService: Setting isFromDeeplink = true for detail page'
      );
      this.dataService.isFromDeeplink = true;
      this.router.navigate([payload.contentType, payload.resourceId], {
        state: {
          resourcevm: {
            contentType: payload.contentType,
            uniqueId: payload.resourceId,
          },
        },
      });
    }
  }

  private redirectToPlayer(payload: AdaptedPayload) {
    this.dataService.isFromDeeplink = true;
    this.router.navigate(['player', payload.contentType, payload.resourceId], {
      state: {
        resourcevm: {
          contentType: payload.contentType,
          uniqueId: payload.resourceId,
        },
      },
    });
  }

  private autoSkipOnboarding(): void {
    console.log('🚀 TizenService: Auto-skipping onboarding for deeplink');

    // 1. Mark onboarding as complete
    const isFirstLaunch = this.localStorage.getItem(KEYS.IS_FIRST_LAUNCH);
    if (!isFirstLaunch || !isFirstLaunch?.length) {
      this.localStorage.setItem(KEYS.IS_FIRST_LAUNCH, 'true');
    }

    // 2. Set default languages for anonymous users to skip language selection
    const currentLanguages = this.localStorage.getItem(
      KEYS.ANONYMOUS_PREFERRED_LANGUAGES
    );
    if (
      !this.authService.isLoggedIn() &&
      (!currentLanguages || !currentLanguages.length)
    ) {
      this.localStorage.setItem(KEYS.ANONYMOUS_PREFERRED_LANGUAGES, 'te,ta');
    }

    // 3. Set flag to skip preferred language selection screen
    this.dataService.skipPreferredLanguageSelection = true;
  }
}
